module.exports = __webpack_public_path__ + "img/valley_oak_997d_detail_rsh.93d64c9d.jpg";